"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'config.tooltips.chat.pick.kdb': '选择知识数据库以获得增强响应',
    'config.tooltips.chat.settings': '打开聊天设置以配置选项',
    'config.tooltips.send.prompt': '发送提示',
    'config.tooltips.prompt.with.microphone': '使用麦克风输入',
    'config.tooltips.attach.file.to.prompt': '附加文件到提示',
    'config.tooltips.cancel.request': '取消请求',
};
